<script lang="ts">
	export let info;

	const currentYear = new Date().getFullYear();
</script>

<footer class="bg-black text-white">
	<div class="container pt-md-5 pt-4 pb-2 px-md-5 px-3">
		<div class="row g-0 align-items-start ">
			<div class="col-md-4 px-md-3 mb-4">
				<h2 class="fw-bold fs-3 text-uppercase mb-md-3 mb-2">Only You Bali Tours</h2>
				<p class="lh-sm fw-light">Your experiences our pride. Hear what our travelers have to say!</p>
				<div class="d-flex">
					<a href="{info.instagram}" target="_blank" class="text-decoration-none text-white"><i class="ri-instagram-line fs-4 me-2"></i></a>
					<a href="{info.facebook}" target="_blank" class="text-decoration-none text-white"><i class="ri-facebook-line fs-4 me-2"></i></a>
					<a href="{info.tiktok}" target="_blank" class="text-decoration-none text-white"><i class="ri-tiktok-line fs-4 me-2"></i></a>
				</div>
			</div>
			<div class="col-md-3 offset-md-1 px-md-3 mb-4">
				<h2 class="fw-semibold fs-5 text-uppercase mb-md-3 mb-2">Site Link</h2>
				<p class="lh-sm mb-1 fw-light"><a href="/" class="text-decoration-none text-white">Home</a></p>
				<p class="lh-sm mb-1 fw-light"><a href="/" class="text-decoration-none text-white">Our Packages</a></p>
				<p class="lh-sm mb-1 fw-light"><a href="/" class="text-decoration-none text-white">Airport Transfer</a></p>
				<p class="lh-sm mb-1 fw-light"><a href="/" class="text-decoration-none text-white">Activities</a></p>
				<p class="lh-sm mb-1 fw-light"><a href="/" class="text-decoration-none text-white">Tickets</a></p>
				<p class="lh-sm mb-1 fw-light"><a href="/" class="text-decoration-none text-white">About Us</a></p>
			</div>
			<div class="col-md-4 px-md-3 mb-4">
				<h2 class="fw-semibold fs-5 text-uppercase mb-md-3 mb-2">Contact</h2>
				<div class="lh-sm mb-2">
					<a href="tel:{info.phone}" target="_blank" class="d-flex text-decoration-none text-white">
						<i class="ri-phone-line fs-5 align-middle me-2"></i>
						<span class="fw-light">{info.phone}</span>
					</a>
				</div>
				<div class="lh-sm mb-2">
					<a href="{info.wa}" target="_blank" class="d-flex text-decoration-none text-white">
						<i class="ri-whatsapp-line fs-5 align-middle me-2"></i>
						<span class="fw-light">{info.phone}</span>
					</a>
				</div>
				<div class="lh-sm mb-2">
					<a href="{info.address_link}" target="_blank" class="d-flex text-decoration-none text-white">
						<i class="ri-map-pin-line fs-5 align-middle me-2"></i>
						<span class="fw-light">{info.address}</span>
					</a>
				</div>
			</div>
			<div class="col-md-12 mt-3 px-md-3 text-center">
				<small>Copyright © {currentYear} {info.name} - All Rights Reserved. Website design and manage by <a href="https://magotadigital.com" target="_blank" class="text-decoration-none text-white">Magota Digital</a></small>
			</div>
		</div>
	</div>
</footer>